var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabsPaginationForwardIcon = function SvgTabsPaginationForwardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 24,
    fill: "currentColor",
    rx: 12,
    transform: "rotate(-90 0 24)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    fillRule: "evenodd",
    d: "M13.75 11.175a1.167 1.167 0 0 1 0 1.65l-3.088 3.088a.583.583 0 1 1-.825-.825L12.925 12 9.837 8.912a.583.583 0 0 1 .825-.824z",
    clipRule: "evenodd"
  })));
};
export default SvgTabsPaginationForwardIcon;